











 

















const node = {
  "kind": "InlineDataFragment",
  "name": "useGotoNext_meeting"
};

(node ).hash = "2539e4babbccf509ea336f29825b1ea1";

export default node;
